import * as types from '../../mutationTypes';

export default {
  /* eslint-disable no-param-reassign */
  [types.RESET_CLIENT_CONTEXT](state) {
    state.context = {};
    state.keys = [];
  },

  [types.BULK_ADD_CLIENT_CONTEXT_ITEMS](state, data) {
    state.keys = [];
    state.context = data.context.reduce((result, contextItem) => {
      // Find the context key definition if it is a CS defined context
      // item.
      const item = { ...contextItem };

      // KLUDGE, Vue code calls includes on tags
      if (!item.tags) item.tags = [];

      // We've had cases where multiple client contexts have
      // pointed to the same key definition in backend data.
      // e.g. CSPD-148 CompanyNames, CompanyName's
      // Previously state.context was getting single key, state.keys was
      // getting an additional entry.
      result[item.key] = item;
      state.keys.push(item.key);

      return result;
    }, {});
  },

  [types.UPDATE_CLIENT_CONTEXT_ITEM](state, item) {
    const { key } = item;
    if (state.context[key] === undefined) {
      // eslint-disable-next-line
      state.keys.some((itemKey) => {
        if (state.context[itemKey].key.toLowerCase() === key.toLowerCase()) {
          state.context[itemKey].value = item.value;
          state.context[itemKey].ownerId = item.ownerId;
          state.context[itemKey].valueHtml = item.valueHtml;
          state.context[itemKey].usePlaceholder = item.usePlaceholder;
          return true;
        }
      });
    } else {
      state.context[key].valueHtml = item.valueHtml;
      state.context[key].value = item.value;
      state.context[key].ownerId = item.ownerId;
      state.context[key].usePlaceholder = item.usePlaceholder;
    }
  },

  [types.UPDATE_CHILD_CONTEXT_ITEM]() {},

  [types.BULK_ADD_PREVIOUS_CLIENT_CONTEXT_ITEMS](state, data) {
    state.previousKeys = [];
    state.previousContext = data.reduce((result, contextItem) => {
      const item = { ...contextItem };

      result[item.key] = item;
      state.previousKeys.push(item.key);

      return result;
    }, {});
  },

  // once more fields are supported, we can consider renaming this to BULK_UPDATE_CLIENT_CONTEXT_ITEMS
  [types.BULK_UPDATE_IMPACTED_CLIENT_CONTEXT_ITEMS](state, items) {
    items.forEach((item) => {
      const { id } = item;

      // Find the context item by id using id from impactedContextKeys array
      const contextItem = Object.values(state.context).find((ctxItem) => ctxItem.id === id);

      if (contextItem) {
        state.context[contextItem.key] = { ...contextItem, ...item };
      }
    });
  }
  /* eslint-enable no-param-reassign */
};
